const RESOURCE_NAME = '/shipments-statistics';

export default axios => ({
    shipmentsStatistics(period, params) {
        return axios.get(`${RESOURCE_NAME}/${period}`, {params});
    },
});